<template>
  <a href="javascript:;" class="app-share" @click="onClose" v-if="visible">
    <img src="static/wx_tip.png">
  </a>
</template>
<script>
  export default {
    computed: {
      visible () {
        return this.$service.common.share
      }
    },
    methods: {
      onClose () {
        this.$service.common.share = false
      }
    }
  }
</script>
<style scoped lang='scss'>
  .app-share {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    text-align: right;
    padding-right: 10px;
    img {
      width: 80%;
    }
  }
</style>



// WEBPACK FOOTER //
// AppShare.vue?7211d03a